var _style, _polygon, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 399.9 149.5",
    style: {
      enableBackground: "new 0 0 399.9 149.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#082121;}\n\t.st1{fill:#33D9B2;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 88.9,0.1 133.3,44.6 177.8,0.1 400,0 400,60.5 196.2,60.5 167.7,89 399.9,89 399.9,149.5 0,149.5  0,89 98.9,89 70.4,60.5 0,60.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.8,0L177.8,0l-44.5,44.6L88.9,0.1V0H0v60.5h70.4L98.9,89H0v60.5h399.9V89H167.7l28.5-28.5H400V0H177.8z  M5,94h98.9l11,11H5V94z M394.9,94v11H151.7l11-11H394.9z M394.9,55.5H194.1L139.7,110h255.2v34.5H5V110h121.9L72.5,55.5H5V21h81.8 l46.5,46.6L179.9,21h215.1V55.5z M177.8,16L177.8,16l-44.5,44.6L88.9,16.1V16H5V5h81.8l46.5,46.6L179.9,5h215.1v11H177.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.840f692d5f5880db56ec7be7d66990d2.svg";
export { ForwardRef as ReactComponent };